import React, { useState, useEffect } from "react";
import { Input } from "@fragments";

export default function Title({ value, onInput }) {
    const [_value, setValue] = useState(value);

    useEffect(() => {
        onInput(_value);
    }, [_value]);

    return (
        <Input.Text
            label="Título da aula"
            placeholder="Título da aula"
            size={100}
            value={_value}
            onInput={setValue}
        />
    );
}
